export enum AnalyticsEvents {
  CUSTOM = "custom_dimensions",
  TEMPO = "user_tempo_em_tela"
}
